export const accountSummary = (state) => {
    return state.accountSummary;
}

export const accountLedger = (state) => {
    return state.accountLedger || {};
}

export const allocation = (state) => {
    return state.allocation;
}

export const ibkramModels = (state) => {
    return state.ibkramModels;
}

export const ledgerModels = (state) => {
    return state.ledgerModels || {};
}

export const portfolioPositionsSimple = (state, rootGetters) => {
    return state.portfolioPositionsSimple || {};
}

export const portfolioAccounts = (state) => {
    return state.portfolioAccounts;
}
